import React from 'react';
import { Link } from 'react-router-dom';
import content from '../data/content';

export default function TeamSection() {
  const getInitials = (name) =>
    name.split(' ').map((n) => n[0]).join('');

  return (
    <section className="section" id="team">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Unser Team</span>
          <h2 className="section-title">Unser Team</h2>
          <p className="section-subtitle">
            Mit geballter IT-Erfahrung setzen wir Ihre Projekte erfolgreich um.
          </p>
        </div>
        <div className="team-grid">
          {content.team.map((member) => (
            <div key={member.id} className="team-card">
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-card-avatar"
                />
              ) : (
                <div className="team-card-avatar-placeholder">
                  {getInitials(member.name)}
                </div>
              )}
              <h3>{member.name}</h3>
              <div className="team-card-role">{member.role}</div>
              <div className="team-card-tags">
                {member.tags.map((tag) => (
                  <span key={tag} className="team-card-tag">{tag}</span>
                ))}
              </div>
              <div className="team-card-availability">
                <span className="dot" /> {member.availability}
              </div>
              <Link to={`/profil/${member.id}`} className="btn btn-outline">
                Profil ansehen
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
